<script setup lang="ts">
  import GPButton from './GPButton.vue';
  import GPContent from './GPContent.vue';
  import GPHTML from './GPHTML.vue';
  import GPImage from './GPImage.vue';
  import GPTitle from './GPTitle.vue';
  import GPVideo from './GPVideo.vue';

  defineProps<{
    content: unknown; // should be exact PBRow[] from 'mp-types/admin' but it doesn't match with public types and API
  }>();

  const elements = {
    button: GPButton,
    content: GPContent,
    html: GPHTML,
    image: GPImage,
    title: GPTitle,
    video: GPVideo,
  };
</script>

<template>
  <div class="page__container">
    <div
      v-for="(row, idxC) in content"
      :key="idxC"
      class="page__row"
    >
      <div
        v-for="(column, idxCol) in row.columns"
        :key="idxCol"
        class="page__column"
      >
        <div
          v-for="(element, idxEl) in column.elements"
          :key="idxEl"
          class="page__element"
        >
          <component
            :is="elements[element.type]"
            :content="element.content"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .page {
    &__container {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      gap: var(--mp-space-70);
    }

    &__row {
      display: flex;
      align-items: flex-start;
      justify-content: stretch;
      gap: var(--mp-space-60);
    }

    &__column {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: var(--mp-space-40);
    }
  }
</style>
